<div class="bespoke-form w-100 h-100 d-flex flex-column page-min-h">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-lg-8">
                <div class="d-flex flex-column flex-grow-1 py-5 px-xl-5">
                    <h2 *ngIf="source === 'onPage'" class="cs__title fs-4 mb-3 text-center mb-5">Request Bespoke Size
                    </h2>
                    <form class="app__form needs-validation" [formGroup]="bespokeForm" (ngSubmit)="onSubmit()"
                        novalidate>

                        <div class="mb-5" *ngIf="!user">
                            <div class="ff-spectral fw-bold fs-3 text-primary mb-3">
                                Product requirements
                            </div>
                        </div>

                        <div class="row mb-3 d-flex align-items-center">
                            <div class="col-12 col-lg-4">
                                <label class="app__label">
                                    Product type
                                </label>
                            </div>
                            <div class="col-12 col-lg-8">
                                <ng-select formControlName="type"
                                    (change)="typeSelected($event)" [clearable]="false" [searchable]="false"
                                    [placeholder]="'Please select'" class="dark"
                                    [ngClass]="{ 'is-invalid': (field.type.touched || formSubmitted) && field.type.errors }">
                                    <ng-option *ngFor="let type of productTypes" [value]="type">{{ type.name }}
                                    </ng-option>
                                </ng-select>
                                <div *ngIf="field.type.hasError && (field.type.touched || formSubmitted)"
                                    class="invalid-feedback mb-1">
                                    <ng-container *ngIf="field.type.hasError('required')">
                                        Please select the product type.
                                    </ng-container>
                                </div>
                            </div>
                        </div>

                        <div class="row mb-3 d-flex align-items-center">
                            <div class="col-12 col-lg-4">
                                <label class="app__label">
                                    Product finish
                                </label>
                            </div>
                            <div class="col-12 col-lg-8">
                                <ng-select formControlName="finish"
                                    (change)="finishSelected($event)" [clearable]="false" [searchable]="false"
                                    [placeholder]="'Please select'" class="dark"
                                    [ngClass]="{ 'is-invalid': (field.finish.touched || formSubmitted) && field.finish.errors }">
                                    <ng-option *ngFor="let finish of productFinishes" [value]="finish">{{ finish.name }}
                                    </ng-option>
                                </ng-select>
                                <div *ngIf="field.finish.hasError && (field.finish.touched || formSubmitted)"
                                    class="invalid-feedback mb-1">
                                    <ng-container *ngIf="field.finish.hasError('required')">
                                        Please select the product finish.
                                    </ng-container>
                                </div>
                            </div>
                        </div>


                        <div class="row mb-4 d-flex align-items-center" *ngIf="domainId=='UP'">
                            <div class="col-12 col-lg-4">
                                <label class="app__label">
                                    Product group
                                </label>
                            </div>
                            <div class="col-12 col-lg-8">
                                <ng-select class="dark" [multiple]="false" [clearable]="false"
                                    [placeholder]="'Please select'" [searchable]="false"
                                    (change)="productGroupSelected($event)">
                                    <ng-option [value]="0">Select a product group</ng-option>
                                    <ng-option *ngFor="let item of productGroupData" [value]="item">
                                        <span style="vertical-align: middle;"
                                            [ngClass]="{'subGroup': item.level !=0}">{{item.name}}</span>
                                    </ng-option>
                                </ng-select>

                            </div>
                        </div>

                        <div class="row mb-4 d-flex align-items-center" *ngIf="domainId!='UP'">
                            <div class="col-12 col-lg-4">
                                <label class="app__label">
                                    Product range
                                </label>
                            </div>
                            <div class="col-12 col-lg-8">
                                <ng-select formControlName="range"
                                    (change)="rangeSelected($event)" [clearable]="false" [searchable]="false"
                                    [placeholder]="'Please select'" class="dark"
                                    [ngClass]="{ 'is-invalid': (field.range.touched || formSubmitted) && field.range.errors }">
                                    <ng-option *ngFor="let range of productRanges" [value]="range">{{ range.name }}
                                    </ng-option>
                                </ng-select>
                                <div *ngIf="field.range.hasError && (field.range.touched || formSubmitted)"
                                    class="invalid-feedback mb-1">
                                    <ng-container *ngIf="field.range.hasError('required')">
                                        Please select the product range.
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-4 d-flex align-items-center" *ngIf="domainId=='UP'">
                            <div class="col-12 col-lg-4">
                                <label class="app__label">
                                    Product range
                                </label>
                            </div>
                            <div class="col-12 col-lg-8">
                                <ng-select formControlName="range"
                                    (change)="rangeSelected($event)" [clearable]="false" [searchable]="false"
                                    [placeholder]="'Please select'" class="dark"
                                    [ngClass]="{ 'is-invalid': (field.range.touched || formSubmitted) && field.range.errors }">
                                    <ng-option *ngFor="let range of productGroupRanges" [value]="range">{{ range.name }}
                                    </ng-option>
                                </ng-select>
                                <div *ngIf="field.range.hasError && (field.range.touched || formSubmitted)"
                                    class="invalid-feedback mb-1">
                                    <ng-container *ngIf="field.range.hasError('required')">
                                        Please select the product range.
                                    </ng-container>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="field.range.value && restrictions" [@fadeIn]>
                            <app-bespoke-size-form [product]="product" [restrictions]="restrictions"
                                [subTypes]="subTypes" [allowRandom]="allowRandom" [costsSQM]="costsSQM"
                                [heightValidation]="heightValidation" (validHeight)="setValidHeight($event)"
                                (validQuantity)="setValidQuantity($event)"></app-bespoke-size-form>
                        </div>

                        <div *ngIf="field.range.value" [@fadeIn]>
                            <app-bespoke-subtype-form [product]="product" [subTypes]="subTypes">
                            </app-bespoke-subtype-form>
                        </div>

                        <div *ngIf="field.type.value && field.type.value.id === 'steps'" [@fadeIn]>

                            <div class="mb-5">
                                <div class="ff-spectral fw-bold fs-3 text-primary mb-3">
                                    Product Corners
                                </div>
                                <div class="ff-spectral fs-6 text-primary">
                                    How many of these {{product.type.name.toLowerCase()}} should be corners / end
                                    pieces?
                                </div>
                            </div>
                            <app-bespoke-corners-form [product]="product"></app-bespoke-corners-form>

                            <app-bespoke-riser-form [product]="product"></app-bespoke-riser-form>
                        </div>

                        <div *ngIf="field.range.value" class="row mb-3">
                            <div class="col-12 col-lg-4">
                                <label class="app__label">
                                    Notes
                                </label>
                            </div>
                            <div class="col-12 col-lg-8">
                                <textarea [(ngModel)]="product.notes" [ngModelOptions]="{standalone: true}"
                                    class="form-control" style="height: 150px; max-height: unset;"
                                    placeholder="Please tell us about your bespoke requirements"></textarea>
                            </div>
                        </div>

                        <div *ngIf="field.range.value" class="row mb-3">
                            <div class="col-12 col-lg-4 d-flex flex-column">
                                <label class="app__label">File upload</label>
                            </div>
                            <div class="col-12 col-lg-8">
                                <app-file-uploader [uploadConfig]="uploadConfig" [ownerType]="'bespoke'"
                                    (success)="onUploadSuccess($event)"></app-file-uploader>
                            </div>
                        </div>

                        <ng-container *ngIf="!user">
                            <div class="mb-5">
                                <div class="ff-spectral fw-bold fs-3 text-primary mb-3">
                                    Contact details
                                </div>
                            </div>
                            <div class="mb-3 d-flex align-items-center">
                                <input id="trade" type="checkbox" [checked]="isTradeCustomer"
                                    (change)="onChangeTrade($event)" class="custom-checkbox" />
                                <label for="trade" class="form-check-label">I am a trade customer</label>
                            </div>

                            <div class="mb-3 d-flex align-items-center" *ngIf="!user">
                                <input id="register-with-ys" type="checkbox" [checked]="registerWithYs"
                                    (change)="registerWithYs = !registerWithYs" class="custom-checkbox" />
                                <label for="register-with-ys" class="form-check-label">Register with us</label>
                            </div>

                            <div class="row mb-3 d-flex align-items-center" *ngIf="isTradeCustomer">
                                <div class="col-12 col-lg-4">
                                    <label class="app__label">
                                        Company name
                                    </label>
                                </div>
                                <div class="col-12 col-lg-8 position-relative">
                                    <input type="text" class="form-control"
                                        formControlName="company" placeholder="Please enter your company name"
                                        [ngClass]="{ 'is-invalid': (field.company.touched || formSubmitted) && field.company.value == '' }" />
                                    <div *ngIf="field.company.value == '' && (field.company.touched || formSubmitted)"
                                        class="invalid-feedback mb-1">
                                        <ng-container *ngIf="field.company.value == ''">
                                            Please enter your company name.
                                        </ng-container>
                                    </div>
                                    <span class="text-danger required-input">*</span>
                                </div>
                            </div>

                            <div class="row mb-3 d-flex align-items-center">
                                <div class="col-12 col-lg-4">
                                    <label class="app__label">
                                        Your name
                                    </label>
                                </div>
                                <div class="col-12 col-lg-8 position-relative">
                                    <input type="text" class="form-control"
                                        formControlName="name" placeholder="Please enter your name"
                                        [ngClass]="{ 'is-invalid': (field.name.touched || formSubmitted) && field.name.errors }" />

                                    <div *ngIf="field.name.hasError && (field.name.touched || formSubmitted)"
                                        class="invalid-feedback mb-1">
                                        <ng-container *ngIf="field.name.hasError('required')">
                                            Please enter your name.
                                        </ng-container>
                                    </div>
                                    <span class="text-danger required-input">*</span>
                                </div>

                            </div>

                            <div class="row mb-3 d-flex align-items-center">
                                <div class="col-12 col-lg-4">
                                    <label class="app__label">
                                        Your email address
                                    </label>
                                </div>
                                <div class="col-12 col-lg-8 position-relative">
                                    <input type="email" class="form-control"
                                        formControlName="email" placeholder="Please enter your email address"
                                        [ngClass]="{ 'is-invalid': (field.email.touched || formSubmitted) && field.email.errors }" />
                                    <div *ngIf="field.email.hasError && (field.email.touched || formSubmitted)"
                                        class="invalid-feedback mb-1">
                                        <ng-container *ngIf="field.email.hasError('required')">
                                            Please enter your email address.
                                        </ng-container>
                                    </div>
                                    <span class="text-danger required-input">*</span>
                                </div>
                            </div>


                            <div class="row mb-3 d-flex align-items-center">
                                <div class="col-12 col-lg-4">
                                    <label class="app__label">
                                        Your telephone number
                                    </label>
                                </div>
                                <div class="col-12 col-lg-8 position-relative">
                                    <ys-phone-input formControlName="telephone"></ys-phone-input>
                                    <span class="text-danger required-input">*</span>
                                </div>
                            </div>

                        </ng-container>

                        <div class="col-12 col-lg-8 offset-lg-4 btn-cta__wrapper mt-34">
                            <button type="submit" [disabled]="!bespokeForm.valid" class="btn btn-primary btn-form-submit">
                                Send request
                            </button>

                            <button type="button" (click)="close()" class="btn btn-outline-primary ms-3">
                                Cancel
                            </button>
                        </div>

                    </form>
                </div>
            </div>
        </div>
    </div>
</div>